import { Card, Statistic } from 'antd';

function CardStatistic({
    title = "",
    valueTotal = "",
    valuePercent = null,
    colorBack = '#e4e4e4ff',
    colorText = '#302e2eff',
    }){
    const colorTextLight = `${colorText}70`;
    return (
    <>
        <Card 
            style={{ 
                borderColor: colorTextLight,
                fontFamily: 'Roboto',               
                background: colorBack, 
                textAlign: 'center'}}
            >            
            <Statistic
                title={
                    <span style={{
                        fontSize: '14px',
                        color: colorText,
                        marginLeft: '4px'
                    }}>
                        {title}
                    </span>}
                formatter={(value) => value.toLocaleString('pt-BR')}
                value={valueTotal}
                valueStyle={{ color: colorText }}
                suffix={
                    <span style={{ 
                        fontSize: '16px',
                        color: colorTextLight,
                        marginLeft: '4px'
                    }}>
                        ({valuePercent}%)
                    </span>
                }
            />
        </Card>
    </>)
}

export default CardStatistic;